import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  app_code: undefined, // required - Mã ứng dụng
  app_name: undefined, // required - Tên ứng dụng
  index: undefined, // required - Thứ tự
  percentage_discount: undefined, // optional - Giảm giá %
  money_discount: undefined, // optional - Tiền giảm giá
  disabled: undefined, // required - Trạng thái Khóa/Mở khóa
  method_discount: undefined,
};

// validation form
model.validForm = {
  app_code: [ValidService.required, ValidService.checkSpace], // required - Mã ứng dụng
  app_name: [ValidService.required, ValidService.checkSpaceString], // required - Tên ứng dụng
  index: [ValidService.required, ValidService.checkNumberInteger], // required - Thứ tự
  percentage_discount: [ValidService.checkNumberFloatNotNegative], // optional - Giảm giá %
  money_discount: [ValidService.checkPositiveNumberInteger], // optional - Tiền giảm giá
  disabled: [ValidService.required], // required - Trạng thái Khóa/Mở khóa
  method_discount: [ValidService.requiredChange],
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "-created_time",
    defaultSort: ["created_time", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
      value: {
        app_name: '',
        app_code: '',
        disabled: '',
        percentage_discount: '',
        money_discount: ''
      },
      valid: {
        app_name: [],
        app_code: [ValidService.checkSpace],
        disabled: [],
        percentage_discount: [],
        money_discount: []
      },
      operator: {
        app_name: ':regex_i:',
        app_code: ':regex_i:',
        disabled: ':regex_i:',
        percentage_discount: '',
        money_discount: ''
      }
  }
};

export default model;
